import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { StyledIcon } from '../Icon.style.js';

const Svg = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React__default.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React__default.createElement("path", {
  d: "m5.8 5.8 12 12",
  strokeLinecap: "round"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "m17.8 5.8-12 12",
  strokeLinecap: "round"
})));
const SvgX = (_ref, ref) => {
  let {
    ariaLabel,
    baseline,
    block,
    className,
    color,
    size
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledIcon, {
    $baseline: baseline,
    $block: block,
    $color: color,
    $size: size,
    "aria-hidden": ariaLabel ? undefined : true // if ariaLabel is given, icon is visible for screen reader
    ,
    "aria-label": ariaLabel,
    as: Svg,
    className: className,
    "data-icon": "x",
    ref: ref,
    role: ariaLabel ? undefined : 'presentation' // is icon informational or just presentational
  });
};

const X = /*#__PURE__*/React__default.forwardRef(SvgX);
X.displayName = 'XIcon';
X.propTypes = {
  /**
   * Label for assistive technology. When set, icon is read by screen reader.
   */
  ariaLabel: PropTypes.string,
  baseline: PropTypes.bool,
  block: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Color of the icon. For non-fill type of icons, use success-dark for better contrast
   */
  color: PropTypes.oneOf(['primary', 'secondary', 'success', 'success-dark', 'warning', 'danger', 'dark', 'brand', 'white']),
  size: PropTypes.oneOf(['md', 'lg', 'xl', 'xxl', 'xxxl', 'layout-lg', 'layout-xl'])
};
var XIcon = X;

export { XIcon as default };
